import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import ActionButton from "./ActionButton";

type Props = {
  intl: intlShape;
};

function CreateActionButton(props: Props) {
  return (
    <ActionButton
      {...props}
      icon="icon-eh-new"
      defaultLabel={props.intl.formatMessage({ id: "button.create" })}
    />
  );
}

export default injectIntl(CreateActionButton);
